export default __webpack_public_path__ + "static/media/prio_2.4adffea9.svg";